import { render, staticRenderFns } from "./ManagerInviteModel.vue?vue&type=template&id=53da5f6b&"
import script from "./ManagerInviteModel.vue?vue&type=script&lang=js&"
export * from "./ManagerInviteModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports